import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import BackNext from '../../Common/SubComponents/BackNext';
import { Form, Row, Col, Container } from 'react-bootstrap';
import { ConvertStringToBoolean, ConvertBooleanToString } from '../../../Helpers/Formatters/ConvertBoolean';
import { CheckboxInput } from '../../../Helpers/Inputs';
import Watch from '../icons/watch.svg?react';
import { FLORIDA, NEW_YORK } from '../../../Helpers/Constants/States';
import { SvgIcon } from '@mui/material';
import IneligibleForm from '../Helpers/Input/IneligibleForm';
import { setNestedValue } from '../Helpers/Constant';
import { string, object, array as yuparray } from 'yup';
import { customValidators } from '../../../Helpers/Validators/customValidators';

export default function ThreeYearEligibility(props) {
  const formMethods = useForm({
    resolver: yupResolver(ThreeYearEligibility.ValidationSchema),
    mode: 'all',
    reValidateMode: 'all',
    defaultValues: props.formState
  });

  const { handleSubmit, trigger, register, setValue } = formMethods;

  const ineligibleDefault = [
    {
      type: '',
      name: [],
      numberOfChildren: '',
      nameofChildren: [],
    },
  ];
  useEffect(() => {
    props.onFieldChange("isVisible", true);
  }, [])

  const state = props.basicInfo.state;

  const handleValueChangeWithIneligible = (field, value) => {
    props.onFieldChange(field, ConvertBooleanToString(value));
    if (value === true) {
      const newForm = ineligibleDefault;
      newForm[0].type = field;
      props.onStepFieldChange(field, ConvertBooleanToString(value), 'ineligible', [...props.formState.ineligible, newForm[0]]);
      setValue('ineligible', [...props.formState.ineligible, newForm[0]]);
    } else {
      props.onStepFieldChange(
        field,
        ConvertBooleanToString(value),
        'ineligible',
        props.formState.ineligible.filter((form, formIndex) => form.type !== field)
      );
      const selectedForm = props.formState.ineligible.filter((form, formIndex) => form.type === field);
      const newForms = props.formState.ineligible.filter((form, formIndex) => form.type !== field);
      let selectedFormIndex;
      if (props.formState.ineligible.length > 0) {
        selectedFormIndex = props.formState.ineligible.findIndex((form) => form.type === field);
      }
      if (selectedForm.length > 0 && selectedFormIndex >= 0) {
        register('ineligible');
        setValue('ineligible', newForms);
      }
    }
  };

  const getLabelForMedicalIssues = () => {
    if (state === FLORIDA) {
      return 'Within the last three years, has anyone to be covered been medically treated or diagnosed by a licensed member of the medical profession for any of the following?';
    } else if (state === NEW_YORK) {
      return 'To the best of your knowledge and belief, within the last three years, has anyone to be covered been medically treated or diagnosed by a member of the medical profession for any of the following?';
    } else {
      return 'Within the last three years, has anyone to be covered been medically treated or diagnosed by a member of the medical profession for any of the following?';
    }
  };

  const noneOfTheAboveDisabled =
    props.formState.heartRelatePain === 'true' ||
    props.formState.atrialFibrillation === 'true' ||
    props.formState.pancreatitis === 'true' ||
    props.formState.crohnsDisease === 'true' ||
    props.formState.alzheimersDisease === 'true' ||
    props.formState.heartDiseaseOrDisorderWithPacemakerOrDefibrillatorImplant === 'true' ||
    props.formState.peripheralVascularDisease === 'true' ||
    props.formState.ulcerativeColitisOrProctitis === 'true' ||
    props.formState.parkinsonsDisease === 'true' ||
    props.formState.senileDementia === 'true';

  useEffect(() => {
    if (noneOfTheAboveDisabled && props.formState.none === 'true') {
      props.onFieldChange('none', 'false');
    } else if (noneOfTheAboveDisabled && props.formState.none !== 'true') {
      trigger('none');
    }
    else if (!noneOfTheAboveDisabled && props.formState.none === 'false') {
      props.onFieldChange('none', 'true');
    }
  }, [noneOfTheAboveDisabled]);

  const getIneligibleComponent = (field, list) => {
    let item;
    list.map((ineligible, index) => {
      if (ineligible.type === field) {
        item = ineligible;
        item.index = index;
      }
    });
    const handleValueChangeloop = (field, type, value, longFieldName) => {
      setValue(longFieldName, value);
      props.onFieldChange(
        'ineligible',
        props.formState.ineligible.map((form, formIndex) => {
          if (type === form.type) {
            if (field === "name")
              form[field] = value;
            else
              setNestedValue(form, field, value);
            return form;
          } else {
            return form;
          }
        })
      );
    };
    const handleChildrenNames = (field, type, value, longFieldName) => {
      const resetIneligible = props.formState.ineligible.map((form, formIndex) => {
        if (type === form.type) {
          if (field === 'numberOfChildren') {
            setNestedValue(form, field, value);
            const previousChildLength = form.nameofChildren.length;
            const totalChild = parseInt(value);
            if (totalChild > previousChildLength) {
              const addChildInput = totalChild - previousChildLength;
              for (let i = 1; i <= addChildInput; i++) {
                if (type === form.type) {
                  form.nameofChildren.push({ name: '' });
                }
              }
            } else {
              const removeChildInput = previousChildLength - totalChild;
              form.nameofChildren.splice(`-${removeChildInput}`);
            }
            return form;
          }
        } else {
          if (type === form.type) {
            setNestedValue(form, field, value);
            return form;
          } else {
            return form;
          }
        }
      })
      props.onFieldChange('ineligible', resetIneligible);
      setValue('ineligible', resetIneligible);
    };
    if (item) {
      return (
        <div>
          <IneligibleForm
            formState={item}
            onChange={(field, value, type, longFieldName) => {
              handleValueChangeloop(field, type, value, longFieldName);
            }}
            ChildChange={(field, value, type, longFieldName) => {
              handleChildrenNames(field, type, value, longFieldName);
            }}
            allProps={props}
            trigger={trigger}
            key={item.index}
            index={item.index}
            customOption={props.getListOfPlanIncludedPerson()}
            noOfChilds={props.noOfChilds ? props.noOfChilds : ''}
          />
        </div>
      );
    }
  };

  return (
    <Container fluid className="border-class threeYearEligibility">
      <Row className="justify-content-center">
        <Col>
          <FormProvider {...formMethods}>
            <Form className="formPage" onSubmit={handleSubmit(props.onNext)}>
              <Row className="justify-content-center mt-4">
                <Col lg={6}>
                  <div className="text-center mb-2 pt-4">
                    {' '}
                    <SvgIcon component={Watch} className="small-icons" color="primary" fontSize="large" />
                  </div>
                  <div className="text-center form-title pb-2">3 Year Medical History</div>
                </Col>
              </Row>
              <Row className="formPage justify-content-center">
                <Col lg={5}>
                  {/* <FormControl component="fieldset"> */}
                  <h6 className='pb-1'>{getLabelForMedicalIssues()}</h6>
                  <div className="checkboxes">
                    <CheckboxInput
                      name="heartRelatePain"
                      id="heartRelatePain"
                      checked={ConvertStringToBoolean(props.formState.heartRelatePain)}
                      onChange={(e) => handleValueChangeWithIneligible('heartRelatePain', e.target.checked)}
                      label="Heart-related chest pain (including angina or acute coronary syndrome)"
                    />
                  </div>
                  {props.formState.heartRelatePain === 'true' && getIneligibleComponent('heartRelatePain', props.formState.ineligible)}
                  <div className="checkboxes">
                    <CheckboxInput
                      name="atrialFibrillation"
                      id="atrialFibrillation"
                      checked={ConvertStringToBoolean(props.formState.atrialFibrillation)}
                      onChange={(e) => handleValueChangeWithIneligible('atrialFibrillation', e.target.checked)}
                      label="Atrial fibrillation"
                    />
                  </div>
                  {props.formState.atrialFibrillation === 'true' && getIneligibleComponent('atrialFibrillation', props.formState.ineligible)}
                  <div className="checkboxes">
                    <CheckboxInput
                      name="pancreatitis"
                      id="pancreatitis"
                      checked={ConvertStringToBoolean(props.formState.pancreatitis)}
                      onChange={(e) => handleValueChangeWithIneligible('pancreatitis', e.target.checked)}
                      label="Pancreatitis"
                    />
                  </div>
                  {props.formState.pancreatitis === 'true' && getIneligibleComponent('pancreatitis', props.formState.ineligible)}
                  <div className="checkboxes">
                    <CheckboxInput
                      name="crohnsDisease"
                      id="crohnsDisease"
                      checked={ConvertStringToBoolean(props.formState.crohnsDisease)}
                      onChange={(e) => handleValueChangeWithIneligible('crohnsDisease', e.target.checked)}
                      label="Crohn's disease"
                    />
                  </div>
                  {props.formState.crohnsDisease === 'true' && getIneligibleComponent('crohnsDisease', props.formState.ineligible)}
                  <div className="checkboxes">
                    <CheckboxInput
                      name="alzheimersDisease"
                      id="alzheimersDisease"
                      checked={ConvertStringToBoolean(props.formState.alzheimersDisease)}
                      onChange={(e) => handleValueChangeWithIneligible('alzheimersDisease', e.target.checked)}
                      label="Alzheimer's disease"
                    />
                  </div>
                  {props.formState.alzheimersDisease === 'true' && getIneligibleComponent('alzheimersDisease', props.formState.ineligible)}
                  <div className="checkboxes">
                    <CheckboxInput
                      name="heartDiseaseOrDisorderWithPacemakerOrDefibrillatorImplant"
                      id="heartDiseaseOrDisorderWithPacemakerOrDefibrillatorImplant"
                      checked={ConvertStringToBoolean(props.formState.heartDiseaseOrDisorderWithPacemakerOrDefibrillatorImplant)}
                      onChange={(e) => handleValueChangeWithIneligible('heartDiseaseOrDisorderWithPacemakerOrDefibrillatorImplant', e.target.checked)}
                      label="Heart disease or disorder with pacemaker or defibrillator implant"
                    />
                  </div>
                  {props.formState.heartDiseaseOrDisorderWithPacemakerOrDefibrillatorImplant === 'true' &&
                    getIneligibleComponent('heartDiseaseOrDisorderWithPacemakerOrDefibrillatorImplant', props.formState.ineligible)}
                  <div className="checkboxes">
                    <CheckboxInput
                      name="peripheralVascularDisease"
                      id="peripheralVascularDisease"
                      checked={ConvertStringToBoolean(props.formState.peripheralVascularDisease)}
                      onChange={(e) => handleValueChangeWithIneligible('peripheralVascularDisease', e.target.checked)}
                      label="Peripheral vascular disease (circulatory problems)"
                    />
                  </div>
                  {props.formState.peripheralVascularDisease === 'true' && getIneligibleComponent('peripheralVascularDisease', props.formState.ineligible)}
                  <div className="checkboxes">
                    <CheckboxInput
                      name="ulcerativeColitisOrProctitis"
                      id="ulcerativeColitisOrProctitis"
                      checked={ConvertStringToBoolean(props.formState.ulcerativeColitisOrProctitis)}
                      onChange={(e) => handleValueChangeWithIneligible('ulcerativeColitisOrProctitis', e.target.checked)}
                      label="Ulcerative colitis or proctitis"
                    />
                  </div>
                  {props.formState.ulcerativeColitisOrProctitis === 'true' && getIneligibleComponent('ulcerativeColitisOrProctitis', props.formState.ineligible)}
                  <div className="checkboxes">
                    <CheckboxInput
                      name="parkinsonsDisease"
                      id="parkinsonsDisease"
                      checked={ConvertStringToBoolean(props.formState.parkinsonsDisease)}
                      onChange={(e) => handleValueChangeWithIneligible('parkinsonsDisease', e.target.checked)}
                      label="Parkinson's disease"
                    />
                  </div>
                  {props.formState.parkinsonsDisease === 'true' && getIneligibleComponent('parkinsonsDisease', props.formState.ineligible)}
                  <div className="checkboxes">
                    <CheckboxInput
                      name="senileDementia"
                      id="senileDementia"
                      checked={ConvertStringToBoolean(props.formState.senileDementia)}
                      onChange={(e) => handleValueChangeWithIneligible('senileDementia', e.target.checked)}
                      label="Senile dementia"
                    />
                  </div>
                  {props.formState.senileDementia === 'true' && getIneligibleComponent('senileDementia', props.formState.ineligible)}
                  <div className="checkboxes">
                    <CheckboxInput
                      name="none"
                      id="none"
                      checked={noneOfTheAboveDisabled === true ? false : true}
                      //checked={ConvertStringToBoolean(props.formState.none)}
                      onChange={(e) => handleValueChangeWithIneligible('none', e.target.checked)}
                      label="None of the above"
                      disabled={noneOfTheAboveDisabled}
                    />
                  </div>
                  {/* </FormControl> */}
                </Col>
              </Row>
              <div className='backnext-wrapper'>
                <BackNext onBack={props.onBack} isAflac={true} continueLabel={{ text: "Next" }} />
              </div>
            </Form>
          </FormProvider>
        </Col>
      </Row>
    </Container>
  );
}

ThreeYearEligibility.propTypes = {
  formState: PropTypes.object.isRequired,
  onNext: PropTypes.func,
  onFieldChange: PropTypes.func.isRequired,
  onBack: PropTypes.func,
};

ThreeYearEligibility.ValidationSchema = object().shape({
  ineligible: yuparray(
    object().shape({
      name: yuparray().of(string().required('Name is required.')).min(1, 'Name is required.'),
      numberOfChildren: string().when('name', {
        is: (name) => name && name.includes('Dependent Child'),
        then: (schema) => schema.required('This field is required.'),
        otherwise: (schema) => schema.notRequired(),
      }),
      nameofChildren: yuparray().when('name', {
        is: (name) => name && name.includes('Dependent Child'),
        then: (schema) => yuparray(
          object().shape({
            name: customValidators.string().isValidNameWithFiftyChar('Child Name is required.', true),
          })
        ),
      }),
    })
  ),
});

ThreeYearEligibility.DefaultFormState = (prefill = false) => {
  return {
    heartRelatePain: 'false',
    atrialFibrillation: 'false',
    pancreatitis: 'false',
    crohnsDisease: 'false',
    alzheimersDisease: 'false',
    heartDiseaseOrDisorderWithPacemakerOrDefibrillatorImplant: 'false',
    peripheralVascularDisease: 'false',
    ulcerativeColitisOrProctitis: 'false',
    parkinsonsDisease: 'false',
    senileDementia: 'false',
    none: 'true',
    ineligible: [],
    isVisible: false,
  };
};
